import { render } from "./P078.vue?vue&type=template&id=87b81f52&scoped=true"
import script from "./P078.vue?vue&type=script&lang=js"
export * from "./P078.vue?vue&type=script&lang=js"

import "./P078.vue?vue&type=style&index=0&id=87b81f52&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b81f52"]])

export default __exports__